import { cartWaitingCollection } from "@/firebase";

const state = {
  cartWaiting: {}
};

const getters = {};

const actions = {
  // eslint-disable-next-line
  getCartWaiting({ commit }, payload) {
    cartWaitingCollection
      .where("client", "==", payload.client)
      .limit(1)
      .onSnapshot(snapshot => {
        if (snapshot.empty) {
          commit("getCartWaiting", {
            client: payload.client,
            totalCopies: 0,
            itemCopies: 0,
            rawZipSize: 0
          });
        } else {
          let tempData = {};
          snapshot.docChanges().forEach(
            change => {
              tempData = Object.assign(change.doc.data(), {
                id: change.doc.id
              });
              //console.log(tempData);
              if (change.type == "added") {
                //console.log("Cart added.");
                commit("getCartWaiting", tempData);
              } else if (change.type == "modified") {
                //console.log("Cart modified.");
                commit("getCartWaiting", tempData);
              } else if (change.type == "removed") {
                //console.log("Cart deleted.");
                //commit("deleteRoom", tempData);
              }
            },
            error => {
              console.log(error);
            }
          );
        }
      });
  }
};

const mutations = {
  getCartWaiting(state, payload) {
    state.cartWaiting = payload;
    //console.log(state.cartWaiting);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
